module.exports = __webpack_public_path__ + "img/logo-factura123.6990079a.jpg";